<template>
    <div id="app">
<!--        <img alt="TextClue logo" src="./assets/logo.png">-->
        <h1 class="title">{{appname}}</h1>
        <router-view class="view"></router-view>

        <footer>
            <hr/>
            <div class="content has-text-centered">
                <p>Free text analyzer. Find top words, top phrases, similarities in text. Do sentiment analysis. Generate word clouds. This site does not use cookies and does not collect any information.</p>
                <p>
                    Support: Click <a href="mailto:incoming+aaltay-textclue-18089513-issue-@incoming.gitlab.com">here</a> to report an issue or send feedback.</p>
                <p>
                    <strong>{{appname}}</strong> by <a href="https://altay.me">Ahmet Altay</a>.
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
    import TextAnalyzer from "@/components/TextAnalyzer";
    import NotFound from "@/components/NotFound";
    import './../node_modules/bulma/css/bulma.css';

    import Vue from 'vue';
    import VueRouter from 'vue-router';

    Vue.use(VueRouter)

    const router = new VueRouter({
        mode: 'history',
        base: __dirname,
        routes: [
            { path: '/', component: TextAnalyzer },
//            { path: '/foo', component: TextAnalyzer },
            { path: '*', component: NotFound }
        ]
    });

    export default {
        name: 'App',
        router: router,
        components: {
            // TextAnalyzer
        },
        data: function () {
            return {
                'appname': 'TextClue!'
            }
        }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
